/* @flow */

import * as React from 'react';
import {RadioGroupContext} from './radio-group';

import '../checkbox/checkbox-button.css';

type Props = {
    disabled?: boolean,
    value: string,
    children?: React.Node,
};

export class RadioButton extends React.Component<Props> {
    render() {
        return (
            <RadioGroupContext.Consumer>
                {({name, selectedValue, onChange}) => {
                    const checked = this.props.value === selectedValue;
                    const radioId = `${name}-${this.props.value}`;

                    return (
                        <div styleName='input-button'>
                            <input
                                id={radioId}
                                name={name}
                                type='radio'
                                role='radio'
                                checked={checked}
                                aria-checked={checked}
                                disabled={this.props.disabled}
                                onChange={(e) => this.handleChange(e, onChange)}
                            />
                            <label htmlFor={radioId}>{this.props.children}</label>
                        </div>
                    );
                }}
            </RadioGroupContext.Consumer>
        );
    }

    handleChange = (e: SyntheticInputEvent<*>, onChange: Function) => {
        e.stopPropagation();

        onChange(this.props.value);
    };
}
